<div class="grid">
  <p-messages severity="info">
    <ng-template pTemplate>
      <i class="pi pi-info-circle" style="font-size: 1rem; margin-right: 8px"></i>
      <div class="ml-2:md text-message">
        <p>
          Asegúrate de tener acceso como administrador. Si no eres tú quién administra el sitio,
          contáctate con la persona que tenga acceso.
        </p>
      </div>
    </ng-template>
  </p-messages>

  <form [formGroup]="slackBot" (ngSubmit)="onSubmitTeamId()" class="bodyForm">
    <div class="mt-5">
      <p>
        1.Ingresa el <b>ID de tu espacio de trabajo</b> de Slack. Para identificarlo, abre Slack
        desde tu computador en un navegador web y una vez que cargue la página, la URL aparecerá en
        el siguiente formato: <b>https://app.slack.com/client/TXXXXXX/CXXXXX</b>. El ID de tu
        espacio de trabajo es la cadena que empieza por <b>T</b>.
      </p>
      <div class="inputButton">
        <input pInputText formControlName="teamId" placeholder="Ejemplo: T123456789" />
        <button class="saveButton" type="submit">Guardar</button>
      </div>
      <div class="inputButton">
        <p>2. <b>Instala Globot en Slack </b> desde el siguiente link:</p>
        <a
          href="https://slack.com/oauth/v2/authorize?scope=chat%3Awrite%2Cchannels%3Ahistory%2Cchannels%3Aread%2Capp_mentions%3Aread&amp;user_scope=channels%3Aread%2Cchannels%3Awrite%2Cchat%3Awrite&amp;redirect_uri=https%3A%2F%2F4177-200-83-207-133.ngrok-free.app%2Fslack%2Fredirect&amp;client_id=6335439114116.6355790724480"
          style="
            align-items: center;
            color: #000;
            background-color: #fff;
            border: 1px solid #ddd;
            border-radius: 4px;
            display: inline-flex;
            font-family: Lato, sans-serif;
            font-size: 16px;
            font-weight: 600;
            height: 48px;
            justify-content: center;
            text-decoration: none;
            width: 236px;
          "
          ><svg
            xmlns="http://www.w3.org/2000/svg"
            style="height: 20px; width: 20px; margin-right: 12px"
            viewBox="0 0 122.8 122.8"
          >
            <path
              d="M25.8 77.6c0 7.1-5.8 12.9-12.9 12.9S0 84.7 0 77.6s5.8-12.9 12.9-12.9h12.9v12.9zm6.5 0c0-7.1 5.8-12.9 12.9-12.9s12.9 5.8 12.9 12.9v32.3c0 7.1-5.8 12.9-12.9 12.9s-12.9-5.8-12.9-12.9V77.6z"
              fill="#e01e5a"
            ></path>
            <path
              d="M45.2 25.8c-7.1 0-12.9-5.8-12.9-12.9S38.1 0 45.2 0s12.9 5.8 12.9 12.9v12.9H45.2zm0 6.5c7.1 0 12.9 5.8 12.9 12.9s-5.8 12.9-12.9 12.9H12.9C5.8 58.1 0 52.3 0 45.2s5.8-12.9 12.9-12.9h32.3z"
              fill="#36c5f0"
            ></path>
            <path
              d="M97 45.2c0-7.1 5.8-12.9 12.9-12.9s12.9 5.8 12.9 12.9-5.8 12.9-12.9 12.9H97V45.2zm-6.5 0c0 7.1-5.8 12.9-12.9 12.9s-12.9-5.8-12.9-12.9V12.9C64.7 5.8 70.5 0 77.6 0s12.9 5.8 12.9 12.9v32.3z"
              fill="#2eb67d"
            ></path>
            <path
              d="M77.6 97c7.1 0 12.9 5.8 12.9 12.9s-5.8 12.9-12.9 12.9-12.9-5.8-12.9-12.9V97h12.9zm0-6.5c-7.1 0-12.9-5.8-12.9-12.9s5.8-12.9 12.9-12.9h32.3c7.1 0 12.9 5.8 12.9 12.9s-5.8 12.9-12.9 12.9H77.6z"
              fill="#ecb22e"
            ></path></svg
          >Add to Slack</a
        >
      </div>
      <p>
        3. ¡Listo! Activa tu asistente en este canal y para llamarlo, solo menciona
        <b>"@globot"</b> como lo harías con cualquier otro usuario.
      </p>

      <span style="display: flex; flex-direction: row; gap: 8px; align-items: center"
        ><p-inputSwitch
          formControlName="checked"
          (change)="switchChanged($event)"
        ></p-inputSwitch>
        <p>Activar chatbot en este canal</p></span
      >
    </div>
  </form>
</div>
